import React, { Component } from 'react';
import PropTypes from 'prop-types';

class MarkdownRenderBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.markdownContent !== this.props.markdownContent && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <span className="ai-chat-markdown-fallback">
          {this.props.markdownContent}
        </span>
      );
    }

    return this.props.children;
  }
}

MarkdownRenderBoundary.propTypes = {
  markdownContent: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default MarkdownRenderBoundary;
